import type { UserProfile, Workspace } from "@/api/types";
import { hasCompletedOnboarding } from "@/features/auth/onboardingComplete";

export function needsWorkspaceSetup(workspaces: Workspace[]): boolean {
  return workspaces.length === 0;
}

export function needsOnboarding(user: UserProfile | null, workspaces: Workspace[]): boolean {
  if (needsWorkspaceSetup(workspaces)) return true;
  return !hasCompletedOnboarding(user?.user_id, user?.onboarding_progress ?? 0);
}

export function postAuthPath(
  user: UserProfile | null,
  workspaces: Workspace[],
  redirect = "/",
): string {
  if (needsOnboarding(user, workspaces)) return "/onboarding";
  return redirect;
}
